import './login.less'

import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {LoginForm} from './forms/login';
import {Button} from 'antd';
import {Link} from 'react-router-dom';
import {Env} from '../../../env';

@inject('loginStore')
@observer
class Login extends Component {

  render() {
    const {isLoginInProcess} = this.props.loginStore;

    return (
      <div className="login-page">
        <div>
          <section className="left-section">
            <h2>Добро пожаловать</h2>
            <p>
              Введите логин и пароль, чтобы получить доступ к личному кабинету. Если у вас нет личного кабинета, пройдите регистрацию.
              <p className="footer">
                Возникли вопросы ? Звоните ! {Env.phone}
              </p>
            </p>
            <Link to={'/sign'}>
              <Button size={'large'}>Регистрация</Button>
            </Link>
          </section>
          <section className="right-section">
            <div className="right-side">
              <h1>Авторизация</h1>
              <div className="form-group login-form-container">
                <LoginForm loading={isLoginInProcess} submit={::this.submit} />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }

  submit(values) {
    this.props.loginStore.login(values.userName, values.password);
  }

}

export default Login



// WEBPACK FOOTER //
// ./src/components/pages/auth/login.js